<div style="position: relative">
  <ngx-ui-loader
    [loaderId]="'loader02'"
    [fgsColor]="'#fd9b14'"
    [bgsColor]="'#10b7cb'"
    [bgsPosition]="'bottom-right'"
    [bgsType]="'ball-spin-clockwise'"
    [fgsPosition]="'center-center'"
    [fgsType]="'ball-spin-clockwise'"
    [logoPosition]="'center-center'"
    [overlayColor]="'rgba(40, 40, 40, 0.4)'"
    [pbColor]="'#fd9b14'"
    [pbDirection]="'ltr'"
    [textColor]="'#FFFFFF'"
    [textPosition]="'center-center'"
  ></ngx-ui-loader>
  <router-outlet></router-outlet>
</div>
